import React from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Header from '../../Components/Header';
import Sidebar from '../../Components/Sidebar';
import Status from './Status';
import CertificateIssuers from './CertificateIssuers';
import Completed from './Completed';
import AvailableCertifications from './AvailableCertifications';
import SingleSignOnSideBar from '../../Components/SingleSignOnSideBar';



//adding the comment
const Certificate = () => {

    return (
        <>
        <Header/>
        {/* <Sidebar/> */}
        <SingleSignOnSideBar/>
            <main className="certificates" id="main-content">
                {/* <!-- status ,certificate--> */}
                <div className="row bottom-25">
                    {/* <!-- status --> */}
                    <Status/>
                    {/* <!--certificate  --> */}
                    <CertificateIssuers/>
                </div>
                {/* <!-- completed-section --> */}
                <div className="completed-section bottom-25">
                    <Completed/>
                </div>
                {/* <!-- available-certification --> */}
                <div className="available-certification">
                    <AvailableCertifications/>
                </div>
            </main>
        </>
    )
}

export default Certificate;